// Define action types
export const GET_LIST_CATEGORY = "GET_LIST_CATEGORY";
export const GET_LIST_CATEGORY_SUCCESS = "GET_LIST_CATEGORY_SUCCESS";
export const GET_LIST_CATEGORY_FAILURE = "GET_LIST_CATEGORY_FAILURE";

// Define action types interface
interface GetListCategoryAction {
  type: typeof GET_LIST_CATEGORY;
  payload: any;
}

interface GetListCategorySuccessAction {
  type: typeof GET_LIST_CATEGORY_SUCCESS;
  payload: any;
}

interface GetListCategoryFailureAction {
  type: typeof GET_LIST_CATEGORY_FAILURE;
  payload: any;
}

// Combine action types into a union type
export type CategoryActionTypes =
  | GetListCategoryAction
  | GetListCategorySuccessAction
  | GetListCategoryFailureAction;

// Define the action creators
export const actions = {
  getListCategory: (payload: any): GetListCategoryAction => ({
    type: GET_LIST_CATEGORY,
    payload
  }),

  getListCategorySuccess: (data: any): GetListCategorySuccessAction => ({
    type: GET_LIST_CATEGORY_SUCCESS,
    payload: data,
  }),

  getListCategoryFailure: (error: any): GetListCategoryFailureAction => ({
    type: GET_LIST_CATEGORY_FAILURE,
    payload: error,
  }),
};
